import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {SubscribedComponent} from "../subscribed.component";
import {NbDialogService} from "@nebular/theme";
import {ConfirmDialogComponent} from "../dialogs/confirm-dialog/confirm-dialog.component";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class DirtyDeactivateGuard {

  constructor(private dialog: NbDialogService,
              private translate: TranslateService) {
  }

  warnIfNeeded(component: Pick<SubscribedComponent, 'isDirty'>): boolean|Promise<boolean>{
    if(component.isDirty){
      // Flash an alert
      return this.popup();

    }
    return true;
  }

  canDeactivate(component: SubscribedComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.warnIfNeeded(component);
  }

  private async popup(){
    return await new Promise<boolean>((resolve) => {
      const sub = this.dialog.open<ConfirmDialogComponent>(ConfirmDialogComponent, {
        closeOnBackdropClick: false,
        closeOnEsc: false,
        context: {
          title: 'unsaved',
          yestitle: 'discard'
        }
      }).onClose.subscribe((r: boolean) => {
        sub.unsubscribe();
        return resolve(r);
      });
    });
  }

}
